import React from 'react';
import { Row, Col, Container } from 'react-bootstrap'
import Banner from '../assets/img/Sri Rama-1 1@3x.png'
import Banner1 from '../assets/img/namaskaram 1.png'
import Video from '../assets/img/samplevideo.mp4'
import Layer from '../assets/img/Layer.png'
import Layer1 from '../assets/img/Group.png'
import Layer2 from '../assets/img/Layer_2.png'
import Layer3 from '../assets/img/Layer_3.png'
import homefooter from '../assets/img/homefooterbanner.png'
import homefootertext from '../assets/img/homefootertext.png'
import homefooterMobile from '../assets/img/homefooterbg.png'
import Carousel from 'react-bootstrap/Carousel';  


export default class HomeContent extends React.Component {
  constructor() {
    super();
    this.state = {homeContent:{}};
   
  }
  // Fetching data from JSON when the component mounts
  componentDidMount() {
    
    fetch('https://srkbst.org/data/home.json')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      this.setState({homeContent:data})
      console.log('Fetched data:', data);
      // You can now use the data in your component state
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    }); 
  }     
  render() {
    return (
      <>
<div className="container-fluid page-header p-0 mb-5 wow fadeIn" data-wow-delay="0.1s" style={{ backgroundColor: "#731414" }}>
      <div className="container-fluid text-center p-0" >
      <Carousel>
      <Carousel.Item>
      
      <div className='row'>
             <div className='col-lg-7'>
                <img src={'https://srkbst.org/assets/home/banner.png'} className='w-100 p-3' />
             </div>
             <div className='col-lg-5'> 
              <img src={'https://srkbst.org/assets/home/namaskaram 1.png'} className="d-block mx-auto w-50 " alt="Banner" />
              <h2 className='content fw-light text-center'>Namaskaram</h2>
              <h4 className='content fs-5 fw-light text-center text-yellow'>Welcome to all devotees</h4>
              <hr></hr>
             </div>
          </div>
      </Carousel.Item>
      <Carousel.Item>
       
      <div className='row'>
             <div className='col-lg-12 p-0'>
                <a href='/Athirudram'><img src={'https://srkbst.org/assets/home/homebanner-2.png'} className='w-100' /></a>
             </div>
             {/* <div className='col-lg-5 d-flex flex-column justify-content-center'>               
              <h2 className='content fw-light text-center'>Athirudram 2026</h2>
              <h4 className='content fs-5 fw-light text-center text-warning'>To learn more <a href='/Athirudram' className='text-warning'>Please click the link</a></h4>
              <hr></hr>
             </div> */}
          </div>
      </Carousel.Item>
     
    </Carousel>

          
        
      </div>
  <h4 className='text-center fs-5 p-2' 
  style={{ color: "#731414",backgroundColor: "#FFDB00" }}>
   <marquee behavior="scroll" direction="left" scrollamount="5">
      Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !!Hare Rama Hare Rama, Rama Rama Hare Hare !! Hare Krishna Hare Krishna, Krishna Krishna Hare Hare !! 
  </marquee>
  </h4>
      
</div>

<div className="container-xxl gy-5 py-3">
      <div className="container">
        <div className="row gy-5 mb-5">
          <div className="col-lg-6 p-2 wow fadeInUp" data-wow-delay="0.1s" style={{ backgroundColor: "#731414" }}>
           <img src="https://srkbst.org/assets/home/sabhaImage.png" style={{objectFit:"contain", width: "100%"}}></img>
          </div>
          <div className="col-lg-6  background wow fadeInUp mx-auto customMargin homeContent" data-wow-delay="0.3s">
          <h6 className="text-uppercase mb-2 text-per" >
            {this.state.homeContent!=undefined && this.state.homeContent.homeTitle}
            </h6>
            <p className="mb-0">
            {this.state.homeContent!=undefined && this.state.homeContent.description}
            </p>
          </div>
        </div>
        </div>
  </div>
  <div className="container-xxl py-5">
  <div className="container">
    <div className="row g-4">
      {this.state.homeContent.section !== undefined &&
        this.state.homeContent.section.length > 0 &&
        this.state.homeContent.section.map((item, index) => {
          return (
            <div
              className="col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.1 * (index + 1)}s`}
              key={index}
            >
              <a href={item.link} className="text-decoration-none">
                <div className="team-item rounded" style={{ backgroundColor: item.backgroundColor }}>
                  <div className="team-overlay">
                    <h5 className="team-name"><a href={item.link}>{item.name}</a></h5>                    
                  </div>
                  <img className="img-fluid team-img" src={item.img} alt={item.name} />
                </div>
              </a>
            </div>
          );
        })}
    </div>
  </div>
</div>















    <div className="container-fluid home-footer py-2 mt-5 d-none d-sm-block d-md-block d-lg-block d-xl-block" style={{background: `url(${homefooter})`}}>
      <div className="container py-5 text-center">      
        <img className="animated slideInDown" src={homefootertext} style={{width:"335px"}}/>
      </div>           
    </div>

    <div className="container-fluid home-footer py-2 mt-5 d-block d-sm-none " style={{background: `url(${homefooterMobile})`,height:"200px"}}>
               
    </div>
      </>
    );
  }
}